import { render } from "./VerticalNavbar.vue?vue&type=template&id=a3b6ba00&scoped=true&ts=true"
import script from "./VerticalNavbar.vue?vue&type=script&lang=ts"
export * from "./VerticalNavbar.vue?vue&type=script&lang=ts"

import "./VerticalNavbar.vue?vue&type=style&index=0&id=a3b6ba00&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3b6ba00"]])

export default __exports__